export const NOTIFICATION = 'NOTIFICATION';
export const ERROR = 'ERROR';
export const CUSTOM = 'CUSTOM';
